import * as React from 'react';
import { connect } from 'react-redux';


class DataTable extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      announces : this.props.myAnnounces.hebergement
    };
  }

  componentDidMount(){
    this.setState({
      announces : this.props.myAnnounces.hebergement
    })
  }

  componentDidUpdate(prevProps) {
    console.log(prevProps.myAnnounces.hebergement);
    console.log(this.props.myAnnounces.hebergement);
    if(prevProps.myAnnounces.hebergement !== this.props.myAnnounces.hebergement) {
      this.setState({announces: this.props.myAnnounces.hebergement});
    }
  }

 

    renderHeadingRow = (_cell, cellIndex) => {
      const {headings} = this.props;
      return (
        <Cell
          key={`heading-${cellIndex}`}
          content={headings[cellIndex]}
          header={true}
        />
      )
    };
    
    renderRow = (_row, rowIndex) => {
      const {rows} = this.props;
      console.log(this.props.myAnnounces.hebergement);
      return (
        <tr key={`row-${rowIndex}-${rows.title}`}>
          {rows[rowIndex].map((_cell, cellIndex) => {
            return (
              <Cell
                key={`${rowIndex}-${cellIndex}`}
                content={rows[rowIndex][cellIndex]}
              />
            )
          })}
        </tr>
      )
    };
  
    
    render() {
      const {headings, rows} = this.props;
      this.renderHeadingRow = this.renderHeadingRow.bind(this);
      this.renderRow = this.renderRow.bind(this);
      
      const theadMarkup = (
        <tr className='ann__th' key="heading">
          {headings.map(this.renderHeadingRow)}
        </tr>
      );
  
      const tbodyMarkup = rows.map(this.renderRow);
    
      return (
        <table key={this.props.key} className="Table  col-12">
          <thead className='pt-5'>{theadMarkup}</thead>
          <tbody>{tbodyMarkup}</tbody>
        </table>
      );
    }
  }

  function mapStateToProps(state) {
    return {    
      myAnnounces : state.myAnnounces
    }
  }
  //connect function INJECTS dispatch function as a prop!!
  export default connect(mapStateToProps)(DataTable);

   function Cell({
    content,
    header,
  }) {
  
    const cellMarkup = header ? (
      <th className="Cell Cell_header ">
        {content}
      </th>
    ) : (
      <td className="Cell  tbl__items">
        {content}
      </td>
    );
  
    return (cellMarkup);
  }